import React, { useRef, useState } from "react";
import "./Introduction_Modal.css";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { IDS } from "../../../../utils/IDS";

const Introduction_Modal = ({ video, ...props }) => {

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const handlePlayPause = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }

    setIsPlaying(!isPlaying);
  };
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Introduction_Modal"
      >
        <Modal.Body>
          <div className="content_div">
            <div className="vdo_holder">
              <video
                ref={videoRef}
                controls
                className="inner_vdo"
                src={
                  process.env.PUBLIC_URL + IDS.IMG_URL + video
                }
                autoPlay
                loop
                muted
                playsInline
              />
            </div>

            {/* <div className="play_ntn_div" onClick={handlePlayPause}>
              <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} className="play_icon" />
            </div> */}
          </div>

          <div className="close_btn" onClick={() => { props?.onHide() }}>
            <img src="/assets/images/icons/close.png" className="close_img" />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Introduction_Modal;
